import qs from "qs";
import { GetData } from "./Functions/SettingData";

export const getApiKeyResources = async (apiKeyId) => {
  const config = {
    method: "get",
    url: `/api/v1/api-keys/${apiKeyId}/resources`,
    headers: { "Content-Type": "application/json" },
  };
  return GetData(config);
};

export const getApiKeyResourceList = async (
  apiKeyId,
  { columns = [], pageNum = 1, pageCount = 10, filters = {} } = {}
) => {
  const hasFilters = Object.keys(filters).length > 0;
  const config = {
    method: "get",
    url: `/api/v1/api-keys/${apiKeyId}/resources_list`,
    headers: { "Content-Type": "application/json" },
    params: {
      columns,
      pageNum,
      pageCount,
      ...(hasFilters && { filters: JSON.stringify(filters) }),
    },
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  };
  return GetData(config);
};

export const getClientApiSearchSuggestions = async (query, limit = 5) => {
  const config = {
    method: "get",
    url: "/api/v1/api-keys/search_suggestions",
    headers: { "Content-Type": "application/json" },
    params: {
      columnName: "name",
      columnSearch: query,
      columnLimit: limit,
    },
  };
  return GetData(config);
};

export const getClientApiKeys = async () => {
  const config = {
    method: "get",
    url: "/api/v1/api-keys",
    headers: { "Content-Type": "application/json" },
  };
  return GetData(config);
};
